const FIELD_ERROR_MESSAGE = {
    commonField: {
        required: 'Field is required',
        invalid: '',
    },
    pincode: {
        required: 'Pincode is required',
        invalid: 'Please enter a valid pincode',
    },
    name: {
        required: "Owner's name is required",
        invalid: 'Please enter a valid name',
    },
    financierName: {
        required: "Financier's name is required",
        invalid: 'Please enter a valid name',
    },
    phone: {
        required: 'Mobile number is required',
        invalid: 'Please enter a valid phone number',
    },
    mmv: {
        required: 'Make & model is required',
        invalid: '',
    },
    ncb: {
        required: 'Please select one of the options',
        invalid: '',
    },
    pped: {
        required: 'Policy expiry date is required',
        invalid: '',
    },
    cng: {
        required: 'Please select one of the options',
        invalid: 'External CNG kit value is invalid',
        value: 'External CNG kit value is required',
    },
    regdYear: {
        required: 'Registration year is required',
        invalid: '',
    },
    regdMonth: {
        required: 'Registration months is required',
        invalid: '',
    },
    claimedPolicy: {
        required: 'Please select one of the options',
        invalid: '',
    },
    fuelType: {
        required: 'Fuel type is required',
        invalid: '',
    },
    engine: {
        required: 'Engine number is required',
        invalid: 'Please enter a valid engine number',
    },
    chassis: {
        required: 'Chassis number is required',
        invalid: 'Please enter a valid chassis number',
    },
    email: {
        required: 'Email is required',
        invalid: 'Please enter a valid email address',
    },
    carNumber: {
        required: 'Registration number is required',
        invalid: 'Please enter a valid registration number',
    },
    address: {
        required: 'Address is required',
        invalid: '',
    },
    expiryMonth: {
        required: 'Expiry month is required',
        invalid: '',
    },
    policyStartDate: {
        required: 'New policy start date is required',
        invalid: '',
    },
    previousPolicyInsurer: {
        required: 'Previous insurer is required',
        invalid: 'Please enter a valid name',
    },
    policyDate: {
        required: 'Policy date is required',
    },
    make: {
        required: 'Make is required',
    },
    model: {
        required: 'Fuel type is required',
    },
    variant: {
        required: 'Variant is required',
    },
};

export default FIELD_ERROR_MESSAGE;
